import React from "react"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import {
   commonViewColumns,
   whereUsedColumns,
   sbmCommonViewsCols,
   sbmCommonViewsColsAcceptedandRejected,
   accepedandRejectedCommonViewColumns,
} from "../../constant/Constants"

function ExportToExcel(props) {
   const dataCSV = props.data
   const userType = localStorage.getItem("userType")
   const view = sessionStorage.getItem("view")
   const viewType = props.view

   const columns =
      props.view !== "Search"
         ? view === "SBM"
            ? viewType !== "Accepted" && viewType !== "Rejected"
               ? sbmCommonViewsCols
               : sbmCommonViewsColsAcceptedandRejected
            : viewType !== "Accepted" && viewType !== "Rejected"
              ? commonViewColumns
              : accepedandRejectedCommonViewColumns
         : whereUsedColumns

   const flattenedData = dataCSV.reduce((acc, record) => {
      if (
         record.ImpactedParts.length === 0 &&
         userType === "PG" &&
         view === "PG" &&
         viewType !== "Accepted" &&
         viewType !== "Rejected"
      ) {
         acc.push({
            Name: record.Name,
            Type: record.Type,
            SpecSubType: record.SpecSubType,
            AffRev: record.Rev,
            AffTitle: record.Title,
            ReasonForChange: record.ReasonForChange,
            ReleaseDate: record.ReleaseDate,
            EBPModified: record.EBPModified,
            "Impacted Part": "",
            "Display Type": "",
            Rev: "",
            Title: "",
         })
      } else if (
         record.ImpactedParts.length === 0 &&
         userType === "PG" &&
         view === "PG" &&
         (viewType === "Accepted" || viewType === "Rejected")
      ) {
         acc.push({
            Name: record.Name,
            Type: record.Type,
            SpecSubType: record.SpecSubType,
            AffRev: record.Rev,
            AffTitle: record.Title,
            ReasonForChange: record.ReasonForChange,
            ReleaseDate: record.ReleaseDate,
            EBPModified: record.EBPModified,
            "Impacted Part": "",
            "Display Type": "",
            Rev: "",
            Title: "",
            "Action Taken On": record.actionTakenOn,
            "Action Taken By": record.actionTakenBy,
         })
      } else if (
         userType === "PG" &&
         view === "SBM" &&
         (viewType === "Accepted" || viewType === "Rejected")
      ) {
         acc.push({
            Name: record.Name,
            Type: record.Type,
            SpecSubType: record.SpecSubType,
            AffRev: record.Rev,
            AffTitle: record.Title,
            ReasonForChange: record.ReasonForChange,
            ReleaseDate: record.ReleaseDate,
            EBPModified: record.EBPModified,
            "Action Taken On": record.actionTakenOn,
         })
      } else if (
         userType === "PG" &&
         view === "SBM" &&
         viewType !== "Accepted" &&
         viewType !== "Rejected"
      ) {
         acc.push({
            Name: record.Name,
            Type: record.Type,
            SpecSubType: record.SpecSubType,
            AffRev: record.Rev,
            AffTitle: record.Title,
            ReasonForChange: record.ReasonForChange,
            ReleaseDate: record.ReleaseDate,
            EBPModified: record.EBPModified,
         })
      } else if (
         userType === "SBM" &&
         view === "SBM" &&
         viewType !== "Accepted" &&
         viewType !== "Rejected"
      ) {
         acc.push({
            Name: record.Name,
            Type: record.Type,
            SpecSubType: record.SpecSubType,
            AffRev: record.Rev,
            AffTitle: record.Title,
            ReasonForChange: record.ReasonForChange,
            ReleaseDate: record.ReleaseDate,
            EBPModified: record.EBPModified,
         })
      } else if (
         userType === "SBM" &&
         view === "SBM" &&
         (viewType === "Accepted" || viewType === "Rejected")
      ) {
         acc.push({
            Name: record.Name,
            Type: record.Type,
            SpecSubType: record.SpecSubType,
            AffRev: record.Rev,
            AffTitle: record.Title,
            ReasonForChange: record.ReasonForChange,
            ReleaseDate: record.ReleaseDate,
            EBPModified: record.EBPModified,
            "Action Taken On": record.actionTakenOn,
         })
      }
      if (
         record.ImpactedParts.length !== 0 &&
         userType === "PG" &&
         view === "PG" &&
         viewType !== "accepted" &&
         viewType !== "rejected"
      ) {
         var impactedParts =
            props.view !== "Search"
               ? record.ImpactedParts.slice(0, 5)
               : record.ImpactedParts
         impactedParts.forEach((element) => {
            acc.push({
               Name: record.Name,
               Type: record.Type,
               SpecSubType: record.SpecSubType,
               AffRev: record.Rev,
               AffTitle: record.Title,
               ReasonForChange: record.ReasonForChange,
               ReleaseDate: record.ReleaseDate,
               EBPModified: record.EBPModified,
               "Impacted Part": element.Name,
               "Display Type": element.DisplayType,
               Revision: element.Revision,
               ImpactedTitle: element.Title,
            })
         })
      } else if (
         record.ImpactedParts.length !== 0 &&
         userType === "PG" &&
         view === "PG" &&
         (viewType == "accepted" || viewType == "rejected")
      ) {
         var impactedParts =
            props.view !== "Search"
               ? record.ImpactedParts.slice(0, 5)
               : record.ImpactedParts
         impactedParts.forEach((element) => {
            acc.push({
               Name: record.Name,
               Type: record.Type,
               SpecSubType: record.SpecSubType,
               AffRev: record.Rev,
               AffTitle: record.Title,
               ReasonForChange: record.ReasonForChange,
               ReleaseDate: record.ReleaseDate,
               EBPModified: record.EBPModified,
               "Impacted Part": element.Name,
               "Display Type": element.DisplayType,
               Revision: element.Revision,
               ImpactedTitle: element.Title,
               "Action Taken On": record.actionTakenOn,
               "Action Taken By": record.actionTakenBy,
            })
         })
      }

      return acc
   }, [])

   const handleExport = async () => {
      try {
         const workbook = new ExcelJS.Workbook()
         const worksheet = workbook.addWorksheet("Specifications")

         // Add headers
         const headers = columns.map((col) => col.label)
         worksheet.addRow(headers)

         // Style the header row
         worksheet.getRow(1).font = { bold: true }
         worksheet.getRow(1).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFD3D3D3" },
         }

         // Add data rows
         flattenedData.forEach((item) => {
            const row = columns.map((col) => item[col.value] || "")
            worksheet.addRow(row)
         })

         // Auto-fit columns
         worksheet.columns.forEach((column, index) => {
            let maxLength = headers[index]?.length || 10
            column.eachCell({ includeEmpty: false }, (cell) => {
               const columnLength = cell.value ? cell.value.toString().length : 10
               if (columnLength > maxLength) {
                  maxLength = columnLength
               }
            })
            column.width = maxLength < 10 ? 10 : maxLength + 2
         })

         // Generate buffer and download
         const buffer = await workbook.xlsx.writeBuffer()
         const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
         })
         saveAs(blob, "Specifications.xlsx")
      } catch (error) {
         console.error("Error exporting to Excel:", error)
      }
   }

   return (
      <span
         onClick={handleExport}
         style={{ cursor: "pointer" }}
      >
         Export All Results
      </span>
   )
}

export default ExportToExcel
